import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";
import "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyAv3JHnf3jj9bKUCwQ7EMy09kiQ2fP6p70",
  authDomain: "travio.firebaseapp.com",
  databaseURL: "https://travio.firebaseio.com",
  projectId: "travio",
  storageBucket: "travio.appspot.com",
  messagingSenderId: "352197528316",
  appId: "1:352197528316:web:eb510c87a16d04938c2579",
};

firebase.initializeApp(firebaseConfig);

export const FieldValue = firebase.firestore.FieldValue;
export const db = firebase.firestore();
window.db = db;
export const auth = firebase.auth();
export const storage = firebase.storage();
export const functions = firebase.app().functions("europe-west3");
// For prod
window.functions = functions;
// For emulator
// window.functions = functions.useFunctionsEmulator("http://localhost:5001");
